/**
 * Configuration centralisée pour CCA Caisse
 * Les valeurs sont lues depuis les variables d'environnement VUE_APP_*
 * définies dans .env.production au moment du build
 */

const cca_config = {
    VUE_APP_NAME: process.env.VUE_APP_NAME || 'Clinicaa | Caisse',

    MODULE: {
        clinique: { port: '', name: '' },
        caisse: { port: '' },
        stock: { port: '' },
        rh: { port: '' },
    },

    // URLs complètes - pas de concaténation nécessaire
    C_URL: '',  // Vide - les URLs API sont complètes

    C_CLINIQUE_FE_URL: process.env.VUE_APP_CLINIQUE_FE_URL || '',
    C_CAISSE_FE_URL: process.env.VUE_APP_CAISSE_FE_URL || '',
    C_STOCK_FE_URL: process.env.VUE_APP_STOCK_FE_URL || '',
    C_RH_FE_URL: process.env.VUE_APP_RH_FE_URL || '',

    C_URL_CLINIQUE_API: process.env.VUE_APP_CLINIQUE_API || '',
    C_URL_CAISSE_API: process.env.VUE_APP_CAISSE_API || '',
    C_URL_CONFIG_API: process.env.VUE_APP_CONFIG_API || '',
    C_URL_STOCK_API: process.env.VUE_APP_STOCK_API || '',

    C_URL_ASSET: process.env.VUE_APP_ASSET_URL || '',
    C_URL_CAISSE_ASSET: process.env.VUE_APP_CAISSE_ASSET_URL || '',

    COUNTRY_CODE: process.env.VUE_APP_COUNTRY_CODE || 'tg',
    VILLE: process.env.VUE_APP_VILLE || 'Lomé',

    FOOT_1: process.env.VUE_APP_FOOT_1 || '',
    FOOT_2: process.env.VUE_APP_FOOT_2 || '',
    FOOT_ORD: process.env.VUE_APP_FOOT_ORD || '',
    PDL_PAPIER_ENTETE: process.env.VUE_APP_PDL_PAPIER_ENTETE || '',

    TYPE_CLINIQUE: process.env.VUE_APP_TYPE_CLINIQUE || 'Clinique',
    NOM_CLINIQUE: process.env.VUE_APP_NOM_CLINIQUE || 'CLINIQUE',

    IS_SFE: process.env.VUE_APP_IS_SFE === 'true',
    CAN_SET_PAC: process.env.VUE_APP_CAN_SET_PAC === 'true',
    IS_MODELE_ANALYSE: process.env.VUE_APP_IS_MODELE_ANALYSE !== 'false',

    // Pusher — utilisé par la navbar pour recevoir les évènements 'scan'.
    // Si la clé est vide, on n'instancie pas Pusher (cf. navbar.subscribe).
    PUSHER_APP_KEY: process.env.VUE_APP_PUSHER_APP_KEY || '',
    PUSHER_APP_CLUSTER: process.env.VUE_APP_PUSHER_APP_CLUSTER || 'mt1',
}

export { cca_config }
export default cca_config
